import { render, staticRenderFns } from "./CustomDataFilter.vue?vue&type=template&id=08195ebe&scoped=true&"
import script from "./CustomDataFilter.vue?vue&type=script&lang=js&"
export * from "./CustomDataFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08195ebe",
  null
  
)

export default component.exports